import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { faDoorClosed } from '@fortawesome/pro-regular-svg-icons';
import { Difficulty, StyledButton, SwitchThemeContext } from '@tryhackme/thm-ui-components';
import { ThemeColorMode } from 'src/common/enums';
import { useTrackEventMutation } from 'src/common/slices';
import { NextRoom } from 'src/common/interfaces/room';
import { RoomDetailsData } from 'src/features/room/room.types';
import { StyledStepContent, StyledStepDescription, StyledStepIndicator, StepProgressContainer, StyledStepTitle, StyledNextRoomName, StyledStep, StyledStepsWrapper, StyledStepImgWrapper, StyledRoomImage, StyledRoomTextWrapper, StyledNextRoomToolTip } from './room-step-progress.styles';
export const RoomStepProgress = ({
  nextRoom,
  currentRoom,
  isCompletionModal
}: {
  currentRoom: RoomDetailsData;
  nextRoom: NextRoom;
  isCompletionModal?: boolean;
}) => {
  const rooms = [currentRoom, nextRoom];
  const navigate = useNavigate();
  const {
    theme: themeName
  } = useContext(SwitchThemeContext);
  const isDarkMode = themeName === ThemeColorMode.DARK;
  const [trackEvent] = useTrackEventMutation();
  const handleGoToNextRoom = async () => {
    // eslint-disable-next-line no-void
    await trackEvent({
      event: 'click-next-room-button',
      properties: {
        current_room: currentRoom.code,
        next_room: nextRoom.code,
        clicked_on: 'from_popup'
      }
    });
    navigate(`/jr/${nextRoom?.code}`);
  };
  return <StepProgressContainer data-sentry-element="StepProgressContainer" data-sentry-component="RoomStepProgress" data-sentry-source-file="room-step-progress.tsx">
      <StyledNextRoomName data-sentry-element="StyledNextRoomName" data-sentry-source-file="room-step-progress.tsx">Your next room:</StyledNextRoomName>
      <StyledStepsWrapper $isDarkMode={isDarkMode} data-sentry-element="StyledStepsWrapper" data-sentry-source-file="room-step-progress.tsx">
        {rooms.map((room, index) => <StyledStep to={`/jr/${nextRoom?.code}`} key={room.code} $isCompleted={index === 0}>
            <StyledStepIndicator $isCompleted={index === 0}>
              <FontAwesomeIcon icon={index === 0 ? faCheck : faDoorClosed} />
            </StyledStepIndicator>
            <StyledStepContent $isCompleted={index === 0} $isDarkMode={isDarkMode}>
              <StyledStepImgWrapper>
                <StyledRoomImage src={room.imageURL} alt={room.title} />
              </StyledStepImgWrapper>
              <StyledRoomTextWrapper>
                <div>
                  <StyledStepTitle>{room.title}</StyledStepTitle>
                  <StyledStepDescription>{room.description}</StyledStepDescription>
                </div>
                <Difficulty difficulty={room.difficulty} hasIcon />
              </StyledRoomTextWrapper>
            </StyledStepContent>
            {index === 1 && <StyledNextRoomToolTip>Next room</StyledNextRoomToolTip>}
          </StyledStep>)}
      </StyledStepsWrapper>
      {isCompletionModal && <StyledButton
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    onClick={handleGoToNextRoom} color="primary" variant="solid">
          Go to next room
        </StyledButton>}
    </StepProgressContainer>;
};